export default "__VITE_ASSET___n1UQSU5__"